type RatingTextMap = {
  [key: number]: string;
};

export const RATING_TEXTS: RatingTextMap = {
  0: 'Выберите что-нибудь',
  1: 'Не помог',
  2: 'Скорее не помог',
  3: 'Не помог, но было интересно',
  4: 'Скорее помог',
  5: 'Очень помог, спасибо большое!',
};
